import { Component, Input } from '@angular/core';

export type StatusBannerVariant = 'success' | 'muted' | 'danger';

@Component({
  selector: 'hospitality-bot-status-banner',
  templateUrl: './status-banner.component.html',
  styleUrls: ['./status-banner.component.scss'],
})
export class StatusBannerComponent {
  @Input() variant: StatusBannerVariant = 'muted';
  @Input() icon?: string;
  @Input() text?: string;

  get resolvedIcon(): string {
    if (this.icon) return this.icon;
    if (this.variant === 'danger') return 'pi pi-ban';
    if (this.variant === 'success') return 'pi pi-check-circle';
    return 'pi pi-info-circle';
  }
}
